export default __webpack_public_path__ + "static/media/S2Pay.57fde269.svg";